import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import AddBrandPopup from '@features/crm/brands/AddBrandPopup';
import Brand from '@features/crm/components/Brand';
import BrandType from '@features/crm/components/BrandType';
import SalesFunnelTopHeader from '@features/crm/sales-funel/components/SalesFunnelTopHeader';
import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';
import TargetQuarterDropdown from '@features/crm/components/TargetQuarterDropdown';

import { crmTabs, isCRMManagement, isDirector } from '@utils/Util';

const FilterComponent = ({ activeTab, toggleFilter }) => {
	const {
		SALES_PERFORMANCE,
		PROJECTION_HISTORY,
		PROJECTION,
		GLOBAL_PROJECTION,
		BRANDS,
		DASHBOARD,
		TARGET,
		SALES_FUNNEL
	} = crmTabs;
	const filterData = useSelector((store) => store.filterFieldStore);
	const crmStore = useSelector((state) => state.crmCommonStore);
	const [isShowAddBrand, setIsShowAddBrand] = useState(false);

	const renderFilterFields = () => {
		if (activeTab === BRANDS) {
			return (
				<>
					<div className="single-filter">
						<BrandType />
					</div>
					<div className="single-filter">
						<Brand placeholder={'Parent Company'} />
					</div>
					<div className="single-filter transparent-sort">
						<Sort removedLastModified={true} sortKeyWord={'statusUpdatedAt'} />
					</div>
					<div className="add-new-design">
						<button className="button text size32 px-0" onClick={() => setIsShowAddBrand(true)}>
							<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
							<span className="ml-1">Brands</span>
						</button>
					</div>
					{isShowAddBrand && (
						<AddBrandPopup openModal={isShowAddBrand} closeModal={setIsShowAddBrand} />
					)}
				</>
			);
		} else if (activeTab === TARGET) {
			return (
				<>
					<div className={`single-filter d-flex`}>
						<TargetQuarterDropdown />
					</div>
				</>
			);
		}
	};

	const renderTotalBrandsCount = () => {
		if (activeTab === BRANDS && crmStore?.totalBrands && Object.keys(filterData).length > 0) {
			return crmStore.totalBrands > 1
				? `${crmStore.totalBrands} Brands`
				: `${crmStore.totalBrands} Brand`;
		}
	};

	const isChipAdded = () => {
		return false;
	};

	const renderSearchFieldPlaceHolder = () => {
		if (activeTab === PROJECTION_HISTORY) {
			if (isDirector() || isCRMManagement()) {
				return 'Country/Sales cycle/BDM';
			} else {
				return 'Sales cycle';
			}
		} else if (activeTab === GLOBAL_PROJECTION || crmStore?.projectionChildTab === 'GLOBAL_PROJECTION') {
			return 'Brand & BDM';
		} else if (activeTab === PROJECTION) {
			return 'Brand & Season';
		} else if (activeTab === SALES_FUNNEL) {
			return 'Search';
		} else {
			return 'Brand name';
		}
	};

	return (
		<div className={`filter-container-top pt-2 pb-2 bg-gray ${isChipAdded() ? 'chip-added' : ''}`}>
			<div className="filters">
				{crmStore?.isShowLeftSidePanel && [SALES_FUNNEL].includes(activeTab) && (
					<div
						className={`filter-toggle ${crmStore?.isShowEmptyState ? 'disabled' : ''}`}
						onClick={toggleFilter}
					>
						<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
						<span>Filter</span>
					</div>
				)}
				<p className="regular-14 gray_dark_02 weight-500 mr-2">{renderTotalBrandsCount()}</p>
				<Chip excludeList={activeTab === DASHBOARD ? ['dateRange'] : []} />
			</div>
			<div className="filter-actions sample-dashboard-filter">
				{![PROJECTION_HISTORY, SALES_PERFORMANCE, DASHBOARD, TARGET].includes(activeTab) && (
					<Search placeholder={renderSearchFieldPlaceHolder()} />
				)}
				{[SALES_FUNNEL].includes(activeTab) && <SalesFunnelTopHeader />}
				{renderFilterFields()}
			</div>
		</div>
	);
};

export default FilterComponent;
